import {Component, Input, OnInit} from '@angular/core';
import {NgForm, NgModel} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-field-error-display',
  templateUrl: './field-error-display.component.html',
  styleUrls: ['./field-error-display.component.css']
})
export class FieldErrorDisplayComponent implements OnInit {
  @Input() form: NgForm;
  @Input() control: NgModel;
  @Input() textColor;


  constructor(protected router: Router, public translate: TranslateService) {
  }

  ngOnInit(): void {
  }

  inputFieldCss(control: NgModel, form: NgForm): any {
    return (!control?.valid && control?.touched) || (form?.submitted && !control?.valid) ? 'is-invalid' : '';
  }
  useOldTranslation() {
    return !(this.router.url.includes('personalData') || this.router.url.includes('broker') || this.router.url.includes('photos') ||
      this.router.url.includes('additionalIdentification') || this.router.url.includes('additionalQuestions') || this.router.url.includes('preApproved') ||
      this.router.url.includes('contracts') || this.router.url.includes('referred') || this.router.url.includes('usaIds') ||
      this.router.url.includes('signature') || this.router.url.includes('contactData') || this.router.url.includes('end') ||
      this.router.url.includes('selfie') || this.router.url.includes('contact') || this.router.url == '/' || this.router.url.includes('createBarcode')
    );
  }

}
